import AppLink from "../AppLink";
import PaperlessPostIcon from "../Icons/PaperlessPost";
import FacebookIcon from "../Icons/Facebook";
import InstagramIcon from "../Icons/Instagram";
import TwitterIcon from "../Icons/Twitter";
import AppleAppStoreIcon from "../Icons/AppleAppStore";
import GooglePlayStoreIcon from "../Icons/GooglePlayStore";

const trackingBlockInfo = {
  block_name: "footer",
  block_row: "footer",
};

function FooterSections() {
  return (
    <>
      <div className="col-span-2 lg:col-span-1 py-6 lg:py-0 mx-auto lg:mx-0">
        <AppLink
          href="/"
          tracking={{ id: "footer-home", ...trackingBlockInfo }}
        >
          <PaperlessPostIcon className="h-8 lg:h-9 w-28 lg:w-32" />
        </AppLink>
      </div>
      <div className="col-auto pb-6 lg:pb-8">
        <h3 className="mb-4 tracked-medium text-center lg:text-left text-lapel">
          Help
        </h3>
        <ul className="flex flex-col items-center justify-center lg:items-start space-y-5">
          <li className="paragraph-small text-lapel hover:text-black">
            <AppLink
              href="https://paperlesspost.zendesk.com/hc/en-us"
              tracking={{ id: "paperless-post-help", ...trackingBlockInfo }}
            >
              FAQ
            </AppLink>
          </li>
          <li className="paragraph-small text-lapel hover:text-black">
            <AppLink
              href="https://paperlesspost.zendesk.com/hc/en-us/requests/new?cc=US&request_id=180daf23af4e17da94dadb7bc25fc218"
              tracking={{ id: "paperless-post-contact", ...trackingBlockInfo }}
            >
              Contact us
            </AppLink>
          </li>
          <li className="paragraph-small text-lapel hover:text-black">
            <AppLink
              href="/sitemap"
              tracking={{ id: "paperless-post-sitemap", ...trackingBlockInfo }}
            >
              Sitemap
            </AppLink>
          </li>
          <li className="paragraph-small text-lapel hover:text-black">
            <AppLink
              href="/unsubscribe"
              tracking={{
                id: "paperless-post-unsubscribe",
                ...trackingBlockInfo,
              }}
            >
              Unsubscribe
            </AppLink>
          </li>
        </ul>
      </div>
      <div className="col-auto pb-6 lg:pb-8">
        <h3 className="mb-4 tracked-medium text-center lg:text-left text-lapel">
          Company
        </h3>
        <ul className="flex flex-col items-center justify-center lg:items-start space-y-5">
          <li className="paragraph-small text-lapel hover:text-black">
            <AppLink
              href="/about/"
              tracking={{ id: "paperless-post-about", ...trackingBlockInfo }}
            >
              About
            </AppLink>
          </li>
          <li className="paragraph-small text-lapel hover:text-black">
            <AppLink
              href="/blog/"
              tracking={{ id: "paperless-post-blog", ...trackingBlockInfo }}
            >
              Blog
            </AppLink>
          </li>
          <li className="paragraph-small text-lapel hover:text-black">
            <AppLink
              href="/about/jobs/"
              tracking={{ id: "paperless-post-jobs", ...trackingBlockInfo }}
            >
              Jobs
            </AppLink>
          </li>
        </ul>
      </div>
      <hr className="col-span-2 border-t border-dove lg:hidden" />
      <div className="col-span-2 lg:col-span-1 pt-4 pb-6 lg:pt-0 lg:pb-8">
        <h3 className="hidden lg:block mb-4 tracked-medium text-lapel">
          Stay Connected
        </h3>
        <div className="flex items-center justify-center lg:justify-start space-x-4">
          <AppLink
            href="http://facebook.com/pages/Paperless-Post/80813793793"
            tracking={{
              id: "paperless-post-facebook-page",
              ...trackingBlockInfo,
            }}
          >
            <FacebookIcon width="1rem" height="1rem" />
          </AppLink>
          <AppLink
            href="http://twitter.com/paperlesspost"
            tracking={{
              id: "paperless-post-twitter-feed",
              ...trackingBlockInfo,
            }}
          >
            <TwitterIcon width="1rem" height="1rem" />
          </AppLink>
          <AppLink
            href="http://instagram.com/paperlesspost"
            tracking={{
              id: "paperless-post-instagram-feed",
              ...trackingBlockInfo,
            }}
          >
            <InstagramIcon width="1.25rem" height="1.25rem" />
          </AppLink>
        </div>
        <div className="flex flex-row lg:flex-col items-center lg:items-start justify-center space-x-6 lg:space-x-0 lg:space-y-6 mt-6 lg:mt-4">
          <AppLink
            href="https://paperlesspost.app.link/website_footer"
            tracking={{
              id: "paperless-post-footer-apple-button",
              ...trackingBlockInfo,
            }}
          >
            <AppleAppStoreIcon width="8rem" height="100%" />
          </AppLink>
          <AppLink
            href="https://paperlesspost.app.link/website_footer_android"
            tracking={{
              id: "paperless-post-footer-google-play-button",
              ...trackingBlockInfo,
            }}
          >
            <GooglePlayStoreIcon width="8rem" height="100%" />
          </AppLink>
        </div>
      </div>
    </>
  );
}

export default FooterSections;
